import { Theme } from '@mui/material';

import { MuiTextField } from './components/MuiTextField';
import { MuiButton } from './components/MuiButton';

export const overRideComponents = (theme: Theme) => {
  return {
    MuiTextField: MuiTextField(theme),
    MuiButton: MuiButton(theme),
  };
};
